import moment from "moment";
import { membershipTypes, occupations, paymentMethods } from "../../constants";
import {
    OCCUPATIONS_TRANSLATED,
    MEMBERSHIP_TYPES_FOR_TRACKING,
    PAYMENT_METHODS_TRANSLATED,
    VARIANTS,
    ITEM_QUANTITY,
    CURRENCY,
    EVENTS,
    CLICK_TEXT,
    CLICK_TYPES,
    RESULTS,
    INCOME_LEVEL,
    MEMBER_SITUATIONS_TRANSLATED,
    SALARY_INSURANCE_CHOICES,
} from "./constants-tracking";
// const { v4: uuidv4 } = require('uuid');
import { checkIfTracking } from "../form-utils";
import { v4 as uuidv4 } from "uuid";

// ********** GENERAL INFO **********
// Only steps present in all flows are tracked
// These are listed below
// Documentation: https://gist.github.com/kauff92/9b547296afb60846cef180e24b1a99ca
//
// Track the price from the async retrieved price, even if the member chose to pay later
// Receipt tracking
// Track purchase on pageload excluding insurances
// Track insurance purchases as they happen
// In the insurance purchase event send which category of either Fagforening, A-kasse/Fagforening or A-kasse was purchased as variant

// ********** TRACKED STEPS **********
export const trackedSteps = {
    FullName: {
        stepNumber: 2,
        componentName: "FullName",
        stepName: "Dit navn",
        seenBefore: false,
        path: "/indmeldelse/FullName",
        title: "Indmeldelse - Fulde navn",
    },
    YourSituation: {
        stepNumber: 3,
        componentName: "YourSituation",
        stepName: "Din situation",
        seenBefore: false,
        path: "/indmeldelse/YourSituation",
        title: "Indmeldelse - Din situation",
    },
    ContactInformation: {
        stepNumber: 4,
        componentName: "ContactInformation",
        stepName: "Dine oplysninger",
        seenBefore: false,
        path: "/indmeldelse/ContactInformation",
        title: "Indmeldelse - Kontaktinformation",
    },
    Occupation: {
        stepNumber: 4.1,
        componentName: "Occupation",
        stepName: "Din beskæftigelse",
        seenBefore: false,
        path: "/indmeldelse/Occupation",
        title: "Indmeldelse - Beskæftigelse",
    },
    StudyPlusStudyJob: {
        stepNumber: 4.2,
        componentName: "StudyPlusStudyJob",
        stepName: "Dit studiejob",
        seenBefore: false,
        path: "/indmeldelse/StudyPlusStudyJob",
        title: "Indmeldelse - Studie og job",
    },
    YourIncome: {
        stepNumber: 5,
        componentName: "YourIncome",
        stepName: "Din indkomst",
        seenBefore: false,
        path: "/indmeldelse/YourIncome",
        title: "Indmeldelse - Din indkomst",
    }, // BRUGES TIL ERHVERVSAKTIV
    YourSalaryInsurance: {
        stepNumber: 5.1,
        componentName: "YourSalaryInsurance",
        stepName: "Lønforsikring",
        seenBefore: false,
        path: "/indmeldelse/YourSalaryInsurance",
        title: "Indmeldelse - Lønforsikring",
    },
    MembershipType: {
        stepNumber: 6,
        componentName: "MembershipType",
        stepName: "Medlemskab",
        seenBefore: false,
        path: "/indmeldelse/MembershipType",
        title: "Indmeldelse - Medlemstype",
    },
    AKasseHoursAndEducation: {
        stepNumber: 6.1,
        componentName: "AKasseHoursAndEducation",
        stepName: "Din situation",
        seenBefore: false,
        path: "/indmeldelse/AkasseHoursAndEducation",
        title: "Indmeldelse - A-kasse timer og uddannelse",
    },
    AKasseMembershipType: {
        stepNumber: 6.2,
        componentName: "AKasseMembershipType",
        stepName: "Vælg medlemskab",
        seenBefore: false,
        path: "/indmeldelse/AKasseMembershipType",
        title: "Indmeldelse - A-kasse medlemstype",
    },
    StudyPlusEducationInfo: {
        stepNumber: 6.3,
        componentName: "StudyPlusEducationInfo",
        stepName: "Dine oplysninger",
        seenBefore: false,
        path: "/indmeldelse/StudyPlusEducationInfo",
        title: "Indmeldelse - Studie og uddannelse",
    },
    AKasseRecentGraduateJobAndEducation: {
        stepNumber: 6.4,
        componentName: "AKasseRecentGraduateJobAndEducation",
        stepName: "Dine oplysninger",
        seenBefore: false,
        path: "/indmeldelse/AkasseRecentGraduateJobAndEducation",
        title: "Indmeldelse - A-kasse nyuddannet - job og uddannelse",
    },
    AKassePreviousFundInformation: {
        stepNumber: 6.5,
        componentName: "AKassePreviousFundInformation",
        stepName: "Akasse informationer",
        seenBefore: false,
        path: "/indmeldelse/AkassePreviousFundInformation",
        title: "Indmeldelse - Information om tidligere A-kasse",
    },
    Summary: {
        stepNumber: 7,
        stepName: "Dit overblik",
        componentName: "Summary",
        seenBefore: false,
        path: "/indmeldelse/Summary",
        title: "Indmeldelse - Opsummering",
    },
    PriceOfferAndCoverage: {
        stepNumber: 8,
        componentName: "PriceOfferAndCoverage",
        stepName: "Dit overblik",
        seenBefore: false,
        path: "/indmeldelse/PriceOfferAndCoverage",
        title: "Indmeldelse - Prisoverblik",
    },
    Payment: {
        stepNumber: 9,
        stepName: "Betaling",
        componentName: "Payment",
        seenBefore: false,
        path: "/indmeldelse/Payment",
        title: "Indmeldelse - Betaling",
    },
};

const isTracking = checkIfTracking();

// CURRENT STEP, USED TO TRACK THE CURRENT STEP IN THE FLOW. INITIALIZED TO THE FIRST STEP
let theCurrentStep = {
    stepName: trackedSteps.FullName.stepName,
    stepNumber: trackedSteps.FullName.stepNumber,
};

let tempData = { productName: "", productValue: 0, situation: "", variant: "" };

let stepObject = {
    flow_type: "",
    situation: "Ikke angivet endnu",
    medlemskabstype: "Ikke angivet endnu",
    er_steppet_set_før: false,
};

let underEducation = false;
let skipUnion = false;

// Must be a unique identifier for each member. Intended use is sending a MemberId, but since the process
// of becoming a member may take several months, we use a GUID.
const itemIdGuid = uuidv4();

// In "Membership-application" we used a GUID generated server-side. This logic is now moved to the client-side.
const transactionGuid = uuidv4();

// Data to be collected and sent to Google Tag Manager on the final step
const collectedData = {
    event: EVENTS.MEMBER_REGISTRATION_COMPLETED,
    ecommerce: {
        transaction_id: transactionGuid,
        currency: CURRENCY,
        value: 0,
        situation: null,
        betaling_er_gennemført: null,
        pay_first_rate_now: null,
        payment_type: null,
        items: [
            {
                item_id: itemIdGuid,
                item_name: null,
                price: null,
                variant: null,
                quantity: ITEM_QUANTITY,
            },
        ],
    },
};

// ********** HELPER FUNCTIONS **********
// Used on step "MembershipType" to fill tempData with product name and value

const getProductName = (data) => {
    if (!data) return;
    const { MembershipType, SkipAkasseFlag, SkipUnionFlag } = data;
    if (MembershipType) {
        switch (MembershipType) {
            case membershipTypes.UnionAndUnemploymentFund:
                return MEMBERSHIP_TYPES_FOR_TRACKING.MEMBERTYPEBOTH.name;
            case membershipTypes.Union:
                return MEMBERSHIP_TYPES_FOR_TRACKING.MEMBERTYPEUNION.name;
            case membershipTypes.UnemploymentFund:
                return MEMBERSHIP_TYPES_FOR_TRACKING
                    .MEMBERTYPEUNIMPLOYMENTINSURANCEFUND.name;
        }
    }

    if (SkipAkasseFlag && !SkipUnionFlag)
        return MEMBERSHIP_TYPES_FOR_TRACKING.MEMBERTYPEUNION.name;
    if (!SkipAkasseFlag && SkipUnionFlag)
        return MEMBERSHIP_TYPES_FOR_TRACKING.MEMBERTYPEUNIMPLOYMENTINSURANCEFUND
            .name;
    if (!SkipAkasseFlag && !SkipUnionFlag)
        return MEMBERSHIP_TYPES_FOR_TRACKING.MEMBERTYPEBOTH.name;
};

const getMemberVariant = () => {
    if (tempData && tempData.situation) {
        if (
            tempData.situation === OCCUPATIONS_TRANSLATED.EMPLOYED ||
            tempData.situation === OCCUPATIONS_TRANSLATED.SELF_EMPLOYED ||
            tempData.situation === OCCUPATIONS_TRANSLATED.UNEMPLOYED
        ) {
            return VARIANTS.VARIANT_ERHVERVSAKTIV;
        } else return VARIANTS.VARIANT_STUDERENDE;
    }
};

function getProductId(allValues) {
    if (!allValues) return;
    switch (tempData && tempData.productName) {
        case MEMBERSHIP_TYPES_FOR_TRACKING.MEMBERTYPEBOTH.name:
            return MEMBERSHIP_TYPES_FOR_TRACKING.MEMBERTYPEBOTH.id;
        case MEMBERSHIP_TYPES_FOR_TRACKING.MEMBERTYPEUNION.name:
            return MEMBERSHIP_TYPES_FOR_TRACKING.MEMBERTYPEUNION.id;
        case MEMBERSHIP_TYPES_FOR_TRACKING.MEMBERTYPEUNIMPLOYMENTINSURANCEFUND
            .name:
            return MEMBERSHIP_TYPES_FOR_TRACKING
                .MEMBERTYPEUNIMPLOYMENTINSURANCEFUND.id;
    }
    if (
        allValues.MembershipType ===
        MEMBERSHIP_TYPES_FOR_TRACKING.MEMBERTYPEUNION.name
    )
        return MEMBERSHIP_TYPES_FOR_TRACKING.MEMBERTYPEUNION.id;
    if (
        allValues.MembershipType ===
        MEMBERSHIP_TYPES_FOR_TRACKING.MEMBERTYPEUNIMPLOYMENTINSURANCEFUND.name
    )
        return MEMBERSHIP_TYPES_FOR_TRACKING.MEMBERTYPEUNIMPLOYMENTINSURANCEFUND
            .id;
    if (
        allValues.MembershipType ===
        MEMBERSHIP_TYPES_FOR_TRACKING.MEMBERTYPEBOTH.name
    )
        return MEMBERSHIP_TYPES_FOR_TRACKING.MEMBERTYPEBOTH.id;
}

function getPaymentMethod(data) {
    if (!data) return;
    const { PaymentMethod } = data;

    if (PaymentMethod === paymentMethods.Card)
        return PAYMENT_METHODS_TRANSLATED.PAYMENT_METHOD_CARD;
    else if (PaymentMethod === paymentMethods.MobilePay)
        return PAYMENT_METHODS_TRANSLATED.PAYMENT_METHOD_MOBILEPAY;
    else if (PaymentMethod === paymentMethods.Betalingsservice)
        return PAYMENT_METHODS_TRANSLATED.PAYMENT_METHOD_BETALINGSSERVICE;
}

function getMemberSituation(data) {
    if (!data) return;
    const { MemberSituation } = data;

    if (MemberSituation === occupations.employed)
        return OCCUPATIONS_TRANSLATED.EMPLOYED;
    else if (MemberSituation === occupations.unemployed)
        return OCCUPATIONS_TRANSLATED.UNEMPLOYED;
    else if (MemberSituation === occupations.selfEmployed)
        return OCCUPATIONS_TRANSLATED.SELF_EMPLOYED;
    else if (MemberSituation === occupations.student)
        return OCCUPATIONS_TRANSLATED.STUDENT;
    else if (MemberSituation === occupations.vocationalEducation)
        return OCCUPATIONS_TRANSLATED.VOCATIONAL_EDUCATION;
    else if (MemberSituation === occupations.trainee)
        return OCCUPATIONS_TRANSLATED.TRAINEE;
}

const calculatePriceTotal = (step, data) => {
    if (!data || !step) return;
    if (data.MembershipType) {
        switch (data.MembershipType) {
            case membershipTypes.UnionAndUnemploymentFund:
                return Number(step.Labels.PriceFullMembership).toFixed(2);
            case membershipTypes.Union:
                return Number(step.Labels.PriceUnion).toFixed(2);
            case membershipTypes.UnemploymentFund:
                return Number(step.Labels.PriceAkasse).toFixed(2);
        }
    } else {
        return Number(step.Labels.PriceTextTotalPrice).toFixed(2);
    }
};

const getSalaryInsuranceChoice = (data) => {
    if (!data) return;
    if (data.SalaryInsurance === "HasSalaryInsurance")
        return SALARY_INSURANCE_CHOICES.HAS_SALARY_INSURANCE;
    if (data.SalaryInsurance === "NoSalaryInsurance")
        return SALARY_INSURANCE_CHOICES.NO_SALARY_INSURANCE;
    return SALARY_INSURANCE_CHOICES.NOT_SURE;
};

const getClickType = (type) => {
    if (!type) return;
    if (
        type.toLowerCase().includes("fullmembership") ||
        type.toLowerCase().includes("forbundakasse")
    )
        return MEMBERSHIP_TYPES_FOR_TRACKING.MEMBERTYPEBOTH.name;
    if (
        type.toLowerCase().includes("union") ||
        type.toLowerCase().includes("forbund")
    )
        return MEMBERSHIP_TYPES_FOR_TRACKING.MEMBERTYPEUNION.name;
    return MEMBERSHIP_TYPES_FOR_TRACKING.MEMBERTYPEUNIMPLOYMENTINSURANCEFUND
        .name;
};

// Functions that handle step-specific tracking
const collectDataPriceOfferAndCoveragePurchaseTracking = (step, data) => {
    if (!data || !step) return;
    collectedData.ecommerce.value = calculatePriceTotal(step, data);
    collectedData.ecommerce.items[0].price = collectedData.ecommerce.value;
};

const collectDataPaymentPurchaseTracking = (step, data) => {
    if (!data) return;
    collectedData.ecommerce.items[0].item_name =
        (tempData && tempData.productName) || getProductName(data);
    collectedData.ecommerce.items[0].item_id = getProductId(data);
    collectedData.ecommerce.pay_first_rate_now = data.PayFirstRateNow;
    collectedData.ecommerce.payment_type = getPaymentMethod(data);
    collectedData.ecommerce.items[0].variant =
        data.Education !== undefined
            ? VARIANTS.VARIANT_STUDERENDE
            : VARIANTS.VARIANT_ERHVERVSAKTIV;
};

const handleSituationTracking = (step, data) => {
    if (!data) return;
    fillTempData("situation", getMemberSituation, data);

    sendData({
        event: EVENTS.CHOSEN_MEMBERSITUATION,
        situation: tempData.situation,
    });
};

const handleIncomeLevelTracking = (step, data) => {
    if (!data) return;
    sendData({
        event: EVENTS.CHOSEN_INCOME_LEVEL,
        click_text: data.SolidarityDuesEligible
            ? INCOME_LEVEL.LESS_THAN_27K
            : INCOME_LEVEL.MORE_THAN_27K,
    });
};

const handleSalaryInsuranceTracking = (step, data) => {
    if (!data) return;
    sendData({
        event: EVENTS.CHOSEN_SALARY_INSURANCE,
        click_text: getSalaryInsuranceChoice(data),
    });
};

function fillTempData(key, method, data, step) {
    if (step !== undefined) {
        tempData[key] = method(step, data);
    } else {
        tempData[key] = method(data);
    }
}

// Bruges til at tracke, når brugeren vælger et medlemskab på "MembershipType"
const handleAddToCartTracking = (step, data) => {
    if (!data) return;
    fillTempData("productName", getProductName, data);
    fillTempData("productValue", calculatePriceTotal, data, step);
    fillTempData("variant", getMemberVariant, data);

    sendData({ ecommerce: null });
    sendData({
        event: EVENTS.ADD_MEMBERSHIP_TO_CART,
        ecommerce: {
            currency: CURRENCY,
            value: tempData.productValue,
            situation: collectedData.ecommerce.situation,
            items: [
                {
                    item_id: getProductId(data),
                    item_name: tempData && tempData.productName,
                    price: tempData && tempData.productValue,
                    variant:
                        data.Education !== undefined
                            ? VARIANTS.VARIANT_STUDERENDE
                            : VARIANTS.VARIANT_ERHVERVSAKTIV,
                    quantity: ITEM_QUANTITY,
                },
            ],
        },
    });
};

// Used to send data to Google Tag Manager
function sendData(data) {
    if (!data) return;
    if (!window.dataLayer) throw new Error("No dataLayer");
    isTracking && window.dataLayer.push(data);
}

// Bruges til at tracke, når brugeren skifter betalingsmiddel
export const handleAddPaymentInfoTracking = ({
    PayFirstRateNow,
    PaymentMethod,
}) => {
    if (!PaymentMethod || PayFirstRateNow === undefined) return;
    sendData({ ecommerce: null });
    sendData({
        event: EVENTS.ADD_PAYMENT_INFO,
        ecommerce: {
            currency: CURRENCY,
            value: tempData && tempData.productValue,
            payment_type: PaymentMethod,
            // SKAL BRUGE SITUATION
            situation: collectedData.ecommerce.situation,
            pay_first_rate_now: PayFirstRateNow,
            items: [
                {
                    item_id: collectedData.ecommerce.items[0].item_id,
                    item_name: collectedData.ecommerce.items[0].item_name,
                    price: tempData && tempData.productValue,
                    variant: tempData.variant,
                    quantity: ITEM_QUANTITY,
                },
            ],
        },
    });
};

// ********** EXPORTED FUNCTIONS **********
// Sætter navn og nummer på det nuværende step
export function getNextStepNameAndNumber(step) {
    if (!step) return;
    theCurrentStep.stepName =
        trackedSteps[step.Component] && trackedSteps[step.Component].stepName;
    theCurrentStep.stepNumber =
        trackedSteps[step.Component] && trackedSteps[step.Component].stepNumber;
}

// Bruges til at tracke virtualPageView
export function trackPageView(data) {
    if (!data) return;
    if (!window.dataLayer) throw new Error("No dataLayer");
    if (!data.path || !data.title) return;
    sendData({
        event: EVENTS.VIRTUAL_PAGE_VIEW,
        virtualPagePath: data.path,
        virtualPageTitle: data.title,
    });
    trackInitialStepView(data);
}

// TODO: PROGRESSION BAR HAS BEEN REMOVED TEMPOARILY - IMPLEMENT AFTERWARDS
export function trackProgressBar(data) {
    if (!data) return;
    isTracking &&
        window.dataLayer.push({
            event: EVENTS.PROGRESSION_BAR_CLICKED,
            step_nummer: theCurrentStep.stepNumber,
            step_navn: theCurrentStep.stepName,
            click_text: data,
        });
}

// Bruges til at trække, når brugeren trykker på "Exit" knappen
export function trackExitButton(text) {
    const theText = text || CLICK_TEXT.EXIT;

    isTracking &&
        window.dataLayer.push({
            event: EVENTS.EXIT_CLICKS,
            step_nummer: theCurrentStep.stepNumber,
            step_navn: theCurrentStep.stepName,
            click_text: theText,
        });
}

// Bruges til at tracke, når brugeren skifter flow Erhvervhvervsaktiv/Under uddannelse
export function memberSituationOtherFlowClicked(type, text) {
    if (!type || !text) return;
    sendData({
        event: EVENTS.MEMBER_SITUATION_OTHER_FLOW_CLICKED,
        click_type: type,
        click_text: text,
    });
}

// Bruges til at tracke, når brugeren trykker på "Tilbage" knappen.
export function trackBackButtonClicked(step) {
    getNextStepNameAndNumber(step);
    sendData({
        event: EVENTS.BACK_BUTTON_CLICKED,
        click_type: CLICK_TYPES.BACK,
        click_text: CLICK_TEXT.BACK,
    });
}

// Bruges til at tracke, når brugeren trykker på "Andet" i typeaheads (workplace, studieretning, stilling)
export function trackTypeAheadOtherClicked(searchField) {
    if (!searchField) return;
    sendData({
        event: EVENTS.TYPE_AHEAD_OTHER_CLICKED,
        søgefelt: searchField,
        resultat: RESULTS.SEARCH_FIELD,
    });
}

// Bruges til at tracke fejl på typeahead søgefelt (workplace, studieretning, stilling)
export function trackTypeAheadError(searchField) {
    if (!searchField) return;
    sendData({
        event: EVENTS.TYPE_AHEAD_OTHER_FAIL,
        søgefelt: searchField,
        resultat: RESULTS.SEARCH_FIELD_ERROR,
    });
}

// Bruges til at tracke, når brugeren klikker på tooltip ikonet på "MembershipType" siden.
export function trackInfoButtonClicked(type) {
    if (!type) return;
    sendData({
        event: EVENTS.MEMBERSHIP_TYPE_INFO_ICON_CLICKED,
        click_type: getClickType(type),
        click_text: CLICK_TEXT.INFO_ICON,
    });
}

// Bruges til at tracke, når brugeren klikker på "Se alle fordele" knappen på "Fordele" siden, på mobil.
export function trackMembershipBenefitsMobileClicked(type) {
    if (!type) return;
    sendData({
        event: EVENTS.MEMBERSHIP_BENEFITS_MOBILE_CLICKED,
        click_type: getClickType(type),
        click_text: CLICK_TEXT.MEMBER_BENEFITS_MOBILE,
    });
}

// Bruges til at tracke, når brugeren ændrer startdato på "Summary" siden.
export function trackMembershipStartingDateChanged(newDateText) {
    if (!newDateText) return;
    let date = moment(newDateText).format("DD.MM.YY");
    sendData({
        event: EVENTS.MEMBERSHIP_STARTING_DATE_CHANGED,
        click_text: date,
    });
}

// Tracker når brugeren møder en modal, der blokerer for indmeldelsen
export const modalBlockingRegistration = (data) => {
    if (!data) return;
    sendData({
        event: EVENTS.REGISTRATION_CANT_CONTINUE,
        step_nummer: theCurrentStep.stepNumber,
        step_navn: theCurrentStep.stepName,
        title: data,
    });
};

export const setFlagsForTracking = (skipUnionFlag, underEducationFlag) => {
    underEducation = underEducationFlag;
    skipUnion = skipUnionFlag;
};

// Bruges til at initialisere flow_type. Metoden kaldes i "getInitialStep" i useFlow.
export const setInitialTrackingValues = () => {
    if (skipUnion) {
        if (underEducation) {
            stepObject.flow_type = "Akasse fast track - Under uddannelse";
            trackedSteps.StudyPlusEducationInfo.stepNumber = 5;
            trackedSteps.StudyPlusEducationInfo.stepName = "Din uddannelse";
            trackedSteps.StudyPlusStudyJob.stepNumber = 5.1;
            trackedSteps.StudyPlusStudyJob.stepName = "Dit beskæftigelse";
            trackedSteps.Occupation.stepNumber = 5.2;
            trackedSteps.AKassePreviousFundInformation.stepNumber = 6;
        } else {
            stepObject.flow_type = "Akasse fast track - Erhvervsaktiv";
            trackedSteps.AKasseHoursAndEducation.stepNumber = 5;
            trackedSteps.StudyPlusEducationInfo.stepNumber = 5.1;
            trackedSteps.AKasseRecentGraduateJobAndEducation.stepNumber = 5.2;
            trackedSteps.AKasseMembershipType.stepNumber = 5.3;
            trackedSteps.AKassePreviousFundInformation.stepNumber = 6;
        }
    } else {
        if (underEducation) {
            stepObject.flow_type = "Dobbelt medlemskab - Under uddannelse";
            trackedSteps.Occupation.stepNumber = 5;
            trackedSteps.StudyPlusEducationInfo.stepNumber = 4.1;
            trackedSteps.StudyPlusEducationInfo.stepName = "Din uddannelse";
            trackedSteps.StudyPlusStudyJob.stepNumber = 4.2;
            trackedSteps.AKasseRecentGraduateJobAndEducation.stepNumber = "6.1";
            trackedSteps.AKasseRecentGraduateJobAndEducation.stepName =
                "Din situation";
            if (underEducation && !skipUnion) {
                trackedSteps.Occupation.stepNumber = 5;
            }
            trackedSteps.YourIncome.stepNumber = 6.3;
        } else stepObject.flow_type = "Dobbelt medlemskab - Erhvervsaktiv";
    }
};

// Denne metode kaldes når brugeren ankommer til et step. Metoden sender den data, der er ønsket for step tracking.
// Årsagen til brugen af stepObject er, at den data, der skal sendes, ikke er tilgængelig før step X.
export function trackInitialStepView(data) {
    if (!data) return;
    const currentStep = {
        event: EVENTS.TRACK_STEP,
        step_nummer: trackedSteps[data.componentName].stepNumber,
        step_navn: trackedSteps[data.componentName].stepName,
        step_navn_komponent: trackedSteps[data.componentName].componentName,
        flow_type: stepObject.flow_type,
        situation: stepObject.situation,
        medlemskabstype: stepObject.medlemskabstype,
        er_steppet_set_før: trackedSteps[data.componentName].seenBefore,
    };

    trackedSteps[data.componentName].seenBefore = true;
    sendData(currentStep);
}

// Denne metode kaldes hver gang der trykkes "Næste", og bruges til at indsamle data til de objekter, der leverer
// data til Google Tag Manager
export function trackSubmitStep({ step, data }) {
    if (!data) return;
    if (trackedSteps[step.Component] === undefined) return;
    switch (step.Component) {
        case "YourSituation":
            handleSituationTracking(step, data);
            stepObject.situation = collectedData.ecommerce.situation;
            break;
        case "YourIncome":
            handleIncomeLevelTracking(step, data);
            break;
        case "YourSalaryInsurance":
            handleSalaryInsuranceTracking(step, data);
            break;
        case "MembershipType":
            handleAddToCartTracking(step, data);
            stepObject.medlemskabstype = getProductName(data);
            break;
        case "PriceOfferAndCoverage":
            collectDataPriceOfferAndCoveragePurchaseTracking(step, data);
            break;
        case "Payment":
            collectDataPaymentPurchaseTracking(step, data);
            handleAddPaymentInfoTracking(data);
            break;
        case "StudyPlusEducationInfo":
            if (skipUnion && underEducation && data.IsRecentGraduate) {
                trackedSteps.AKasseRecentGraduateJobAndEducation.stepNumber = 5.1;
            }
    }
}
